import { useQuery } from 'react-query';
import { ApiService } from '@/services/apiService';
import { LocalStorageService } from '@/services/localStorageService';
import { LOCAL_STORAGE_KEYS } from '@/constants';

export const useGetUserDataAndSetInLocalStorage = () => {
	return useQuery('user data', async () => await ApiService.getUserData(), {
		onError: (error: unknown) => {
			const typedError = error as {
				response?: {
					data?: { error?: string };
				};
				message?: string;
			};
			const currentError = typedError?.response?.data?.error || '';

			console.log(
				`Error in getUserData --- ${
					typedError?.message || ''
				} --- ${currentError}`,
			);
		},
		onSuccess: (response: { country_code: string; subdivision: string }) => {
			const { country_code: countryCode, subdivision } = response;

			LocalStorageService.set(LOCAL_STORAGE_KEYS.COUNTRY_CODE, countryCode);
			LocalStorageService.set(LOCAL_STORAGE_KEYS.SUBDIVISION, subdivision);
			LocalStorageService.set(LOCAL_STORAGE_KEYS.USER_DATA, response);
		},
		select: ({ data }) => data,
		enabled: !LocalStorageService.get(LOCAL_STORAGE_KEYS.COUNTRY_CODE, null),
		retry: 1,
	});
};
